/* eslint-disable no-use-before-define,jsx-a11y/anchor-is-valid */
import React from 'react'
import { Loading, hideModal, show } from '../../twd/twd'
import Grid from './grid'
import useSearchModal from './use-search-modal';

export default ({title, ts, searchParams, sort, from, acctNo=''} = {}) => {

    const { status, rows, count } = useSearchModal({ts, searchParams, sort})

    return <React.Fragment>
    <div
        data-name="offerings-modal-close-link"
        className="modal-dialog modal-lg">
    <div className="modal-content">
    <div className="container" style={{background:"#ffffff" }}>

    <div className="row"><div className="col-md-12">
        <div className="vertical-offset-md"></div>
        <button
            className="close"
            aria-label="close"
            data-name="offerings-modal-close-link"
            type="button"
            onClick={() => {
                hideModal()
            }}>
            <i className="material-icons" aria-hidden="true">close</i>
        </button>
    </div></div>

    <div className="row vertical-offset-base">
        <div className="col-md-12 text-center">
            <h2><b>{title}</b></h2>
        </div>
    </div>

    <div className="row vertical-offset-base">
        <Loading status={status}>
        {count===0 && <React.Fragment>
            <div className="col-md-12 text-center">
                <div className="vertical-offset-xs">
                <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
                </div>
                <div className="vertical-offset-xs">
                <div className="small-header vertical-offset-xxs">No security found.</div>
                </div>
            </div>
        </React.Fragment>}

        {count>0 && <Grid {...({rows, sort, searchParams, title, from, acctNo})} />}
        </Loading>
    </div>

    <div className="row vertical-offset-base">
    <div className="col-md-12 text-center">
        <a href="#" onClick={() => {
            hideModal()
            show('advanced-screener', {
                searchParams,
                _ts:Date.now(),
                from,
            })
        }}
        >Open search in advanced screener</a>
    </div>
    </div>
    </div>
    </div>
    </div>

    </React.Fragment>
}
